import { createIntl, createIntlCache } from 'react-intl';
import storage from '@/utils/storage';
import localeInfo from '@/config/locale';

let intlMap: object = {};

const cache = createIntlCache();

export function getLocale() {
  return storage.get('locale') || window.CONFIG?.LOCALE || navigator.language || 'zh-CN';
}

// 默认 zh-CN
export const getIntl = () => {
  const locale = getLocale();
  if (intlMap[locale]) {
    return intlMap[locale];
  }

  if (localeInfo[locale]) {
    return intlMap[locale] = createIntl(localeInfo[locale], cache);
  }
  // 不存在需要一个报错提醒
  console.warn(
    !locale || !!localeInfo[locale],
    'The current popular language does not exist, please check the locales folder!',
  );

  // 如果还没有，返回一个空的
  return createIntl({ locale: 'zh-CN', messages: {} });
};
